import { Text } from "@fluentui/react-northstar";
import styled from "styled-components";

export const ProfileUsername = styled(Text)`
    color: #242424;
    font-size: 18px;
    font-weight: 600;
    line-height: 24px;
    word-wrap: break-word;
`;

export const ProfileJobTitle = styled(Text)`
    color: #242424;
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    word-wrap: break-word;
`;
